import {SignIn} from "@/components";

const Index = () => {
    return(
        <>
            <SignIn />
        </>
    )
}

export default Index;